module.exports = __webpack_public_path__ + "img/ovkasten.5e6226d1.png";